import {fork, put, takeEvery, all} from 'redux-saga/effects';
import config from '../../../config/config';
import {
    LogControllerDtoCommonSafetyCodeLogListRequest, LogControllerDtoCommonSafetyCodeLogListResponse,
    PerplayLogApi,
} from '../../models/src';
import {getErrorMessage} from '../../../utils/serverErrorCheck';
import {SAFETYCODELOG_LIST_REQUEST} from "../../constants/log/safetyCodeLogConstants";

const api = new PerplayLogApi(config.API_CLIENT);

function* safetyCodeLogListRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoCommonSafetyCodeLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = payload.accountNo;
        requestData.contentsIndex = payload.contentsIndex;

        console.log("요청 데이터: ", requestData);

        const result = yield api.apiPerplayLogCommonSafetyCodeLogListPost({logControllerDtoCommonSafetyCodeLogListRequest: requestData}, () => {
        });
        const data = api.apiClient.deserialize(result, LogControllerDtoCommonSafetyCodeLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* safetyCodeLogRootSaga() {
    yield all([
        takeEvery(SAFETYCODELOG_LIST_REQUEST, safetyCodeLogListRequestSaga),
    ])
}

const safetyCodeLogRootSagas = [
    fork(safetyCodeLogRootSaga),
];

export default safetyCodeLogRootSagas;
